import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';

import { DataTypeProvider, } from '@devexpress/dx-react-grid'
// <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{value}</div>
export default class CustomerNameTypeProvider extends Component {
  render() {
    return(
      <DataTypeProvider
        for={["name"]}
        formatterComponent={({ column, row, value }) =>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ width: this.props.onEdit ? "calc(100% - 48px)" : "100%" }}>
              <Tooltip title={value || ""} placement="top-start">
                <Typography noWrap>{value || ""}</Typography>
              </Tooltip>
              <Tooltip title={row.customerRemark || ""} placement="bottom-start">
                <Typography variant="caption" noWrap>{row.customerRemark || ""}</Typography>
              </Tooltip>
            </div>
            { this.props.onEdit ? <IconButton onClick={() => this.props.onEdit(row)}><Icon>edit</Icon></IconButton> : null }
          </div>
        }
        editorComponent={({ column, row, value, onValueChange }) =>
          !row ?
          <TextField
            style={{ margin: 8 }}
            fullWidth
            value={value || ''}
            placeholder={!row ? "Filter..." : ""}
            onChange={event => onValueChange(event.target.value)} /> :
          <div/>
        }
      />
    );
  }
}

CustomerNameTypeProvider.propTypes = {
  onEdit: PropTypes.func,
}
